export interface TimelineItem {
  phase: string;
  title: string;
  desc: string;
}

export const storyTimeline: TimelineItem[] = [
  {
    phase: "起始篇",
    title: "重生与觉醒",
    desc: "唐三自唐门世界重生于斗罗大陆，拜师学艺，觉醒蓝银草与昊天锤双生武魂，初窥魂师之路的门径。",
  },
  {
    phase: "学院篇",
    title: "史莱克七怪成形",
    desc: "唐三与小舞入学史莱克，与戴沐白、朱竹清、奥斯卡、宁荣荣、马红俊并肩修炼，在一次次历练中淬炼实力与情谊。",
  },
  {
    phase: "大赛篇",
    title: "全大陆魂师大赛",
    desc: "七怪站上大陆最高规格的赛场，一路力克强敌，以精彩对决向世人证明史莱克之名。",
  },
  {
    phase: "历练篇",
    title: "海神岛九考",
    desc: "为守护挚爱与同伴，唐三远赴海神岛接受海神九考，在生死磨砺中让魂力与心境一同蜕变。",
  },
  {
    phase: "决战篇",
    title: "武魂殿之战",
    desc: "大陆风云变幻，唐三率众迎战武魂殿，决战以热血与牺牲推向整个故事的最高潮。",
  },
  {
    phase: "终章",
    title: "成神与守护",
    desc: "万难之后，唐三成就海神之位，以更强力量守护挚爱与大陆安宁，主篇故事圆满落幕。",
  },
];